import { Discount, DiscountStatus } from '../types'

export const DISCOUNTS: Discount[] = [
  {
    id: 'd1',
    code: 'ZADAR10',
    type: 'percent',
    value: 10,
    minPurchase: 0,
    uses: 412,
    limit: 1000,
    expiry: '31 dic 2026',
    status: 'activo',
  },
  {
    id: 'd2',
    code: 'BIENVENIDA15',
    type: 'percent',
    value: 15,
    minPurchase: 2000,
    uses: 187,
    limit: 500,
    expiry: '30 sep 2026',
    status: 'activo',
  },
  {
    id: 'd3',
    code: 'ENVIOGRATIS',
    type: 'fixed',
    value: 290,
    minPurchase: 1500,
    uses: 96,
    limit: 300,
    expiry: '31 ago 2026',
    status: 'activo',
  },
  {
    id: 'd4',
    code: 'GLUTEO500',
    type: 'fixed',
    value: 500,
    minPurchase: 3500,
    uses: 54,
    limit: 150,
    expiry: '15 ago 2026',
    status: 'pausado',
  },
  {
    id: 'd5',
    code: 'INVIERNO20',
    type: 'percent',
    value: 20,
    minPurchase: 4000,
    uses: 300,
    limit: 300,
    expiry: '31 jul 2026',
    status: 'vencido',
  },
  {
    id: 'd6',
    code: 'KITPACK25',
    type: 'percent',
    value: 25,
    minPurchase: 5000,
    uses: 12,
    limit: 100,
    expiry: '31 oct 2026',
    status: 'activo',
  },
  {
    id: 'd7',
    code: 'BLACKZADAR',
    type: 'percent',
    value: 30,
    minPurchase: 3000,
    uses: 0,
    limit: 800,
    expiry: '29 nov 2026',
    status: 'pausado',
  },
]

export const DISCOUNT_STATUS_META: Record<
  DiscountStatus,
  { label: string; className: string }
> = {
  activo: {
    label: 'Activo',
    className: 'bg-emerald-500/15 text-emerald-400 border-emerald-500/30',
  },
  pausado: {
    label: 'Pausado',
    className: 'bg-amber-500/15 text-amber-400 border-amber-500/30',
  },
  vencido: {
    label: 'Vencido',
    className: 'bg-red-500/15 text-red-400 border-red-500/30',
  },
}
